exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".App-header {\n    text-align: center;\n    background-image: url(" + require("../images/background/banner.jpg") + ");\n    background-size: 100%;\n}\n\n.App-logo {\n    width: 13%;\n}\n\n.container {\n    width: 100%;\n    padding: 0px;\n}\n\n#NavMenu {\n\tbackground-color: white;\n}\n\n.navbar-nav {\n    width: 100%;\n    text-align: center;\n    margin: 0;\n}\n\n.navbar-nav li{\n    float: none;\n    display: inline-block;\n    font-size: 130%;\n    margin: 0;\n}\n\n.navbar-nav a{\n    text-decoration: none;\n    color: black;\n    display: block;\n    width: 100%;\n}\n\nul.nav li:hover {\n    background-color: #b3b3b3 !important; \n}\n\n@media (min-width: 992px){\n    .navbar-nav li {\n        margin-left : 15px;\n        margin-right : 15px;\n    }\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/app/components/Navigation.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/app/components/Navigation.css
// module chunks = 0